import { render, staticRenderFns } from "./DetectionFilterDefaultLayout.vue?vue&type=template&id=44457134&scoped=true"
import script from "./DetectionFilterDefaultLayout.vue?vue&type=script&lang=js"
export * from "./DetectionFilterDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44457134",
  null
  
)

export default component.exports